import aestheteWeb from '../assets/images/aestheteWeb.png';
import aestheteMob from '../assets/images/aestheteMobile.png';
import mlProject from '../assets/images/SY.png';

export const projects = [
    {
        "title": "Online Art Experience Web Application (Aesthete)",
        "start": "March 2020",
        "end": "Present",
        "location": "San Francisco, California",
        "descrption": "A web applicatin to connect with the people of the same interest and exchange your skill with them. Your passion can be as simple as cooking to teaching/learning mathematics or music lession. It connects the people who share the same interest!",
        "skills": ["React", "Redux", "Thunk", "Saga", "HTML5", "CSS3", "Firebase DB"],
        "githuburl": "https://github.com/sarahysh12/aesthete",
        "image": aestheteWeb
    },
    {
        "title": "Online Art Experience Mobile Application (Aesthete)",
        "start": "May 2020",
        "end": "Present",
        "location": "San Francisco, California",
        "descrption": "An easy to use application for Aesthete to be used on every device", 
        "skills": ["React Native", "Firebase DB"],
        "githuburl": "https://github.com/sarahysh12/aesthete-mobile",
        "image": aestheteMob
    },
    // {
    //     "title": "Random planner (Moody)",
    //     "start": "June 2020",
    //     "end": "Present",
    //     "location": "San Francisco, California",
    //     "descrption": "An iOS application to pick an entertaining and fun plan for your weekends when you're bored and don't have any idea what to do!", 
    //     "skills": ["SwiftUI"],
    //     "githuburl": "https://github.com/sarahysh12/"
    // }
    {
        "title": "Kidney Transplant Failure Prediction Tool",
        "start": "July 2017",
        "end": "May 2018",
        "location": "Bowling Green, Ohio",
        "descrption": "A tool for calculating metrics that have impact on a kidney transplant and predicting the number of days a reciever will live after the transplant", 
        "skills": ["Python", "Machine Learning", "Keras", "Scikit-Learn"],
        "githuburl": "https://github.com/sarahysh12/",
        "image": mlProject
    }

]